import {Injectable} from '@angular/core';
import {GatewayRpcService, Namespace, Version} from "./gateway.rpc.service";

export class Queue {

  queue: any[] = [];
  pendingPromise = false;
  workingOnPromise = false;

  enqueue(promise: any) {
    return new Promise((resolve, reject) => {
      this.queue.push({
        promise,
        resolve,
        reject,
      });
      this.dequeue();
    });
  }

  dequeue() {
    if (this.workingOnPromise) {
      return false;
    }

    if (this.queue.length == 0) {
      this.workingOnPromise = false;
      return false;
    }

    const item = this.queue.shift();

    try {

      this.workingOnPromise = true;

      item.promise()
        .then((value: any) => {
          this.workingOnPromise = false;
          item.resolve(value);
          this.dequeue();
        })
        .catch((err: any) => {
          this.workingOnPromise = false;
          item.reject(err);
          this.dequeue();
        });


    } catch (err) {
      this.workingOnPromise = false;
      item.reject(err);
      this.dequeue();

    }
    return true;
  }
}


@Injectable({
  providedIn: 'root'
})
export class BatchRpcService {

  queueService: Queue;

  constructor(private rpc: GatewayRpcService) {
    this.queueService = new Queue();
  }

  async createBatchDocuments(did: string[], bid: string) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.CreateBatchDocuments, data: {bid, did}});
    } catch (e) {
      return e;
    }
  }

  async updateBatchDocuments(bid: string, newBid: string) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.UpdateBatchDocuments, data: {bid, newBid}});
    } catch (e) {
      return e;
    }
  }

  async getBatchesMajorityShippedStatus(bid: string[]) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.BatchesMajorityShippedStatus, data: {bid}});
    } catch (e) {
      return e;
    }
  }

  async processQuickEdit(res: BatchQuickEdit) {
    try {
      return await this.rpc.request(
        {version: Version.Base, namespace: Namespace.Batch, action: BatchActions.ProcessQuickEdits, data: res});
    } catch (e) {
      return e;
    }
  }
}

export interface BatchQuickEdit {
  editType?: QuickEditType | null;
  batches?: string[];
  shipped?: boolean | null;
  status?: number | null;
  tags?: string[] | null;
  order_numbers?: string[] | null;
  inland_bol?: string[] | null;
  container_numbers?: string[] | null;
  eta?: string | null;
}

export enum QuickEditType {
  ShippingStatus = 0,
  Status = 1,
  Tags = 2,
  Eta = 3,
  OrderNumbers = 4,
  Notes = 5,
  ContainerNumbers = 6,
  InlandBOL = 7
}

export enum BatchActions {
  UpdateBatchDocuments = "UpdateBatchDocuments",
  CreateBatchDocuments = "CreateBatchDocuments",
  BatchesMajorityShippedStatus = "BatchesMajorityShippedStatus",
  ProcessQuickEdits = "ProcessQuickEdits"
}
